var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-round rounded-circle text-white d-inline-block text-center",class:_vm.variant ? 'bg-' + _vm.variant : '',style:({
        minWidth: _vm.size, 
        height: _vm.size,
        fontSize: _vm.fontSize,
        })},[_c('div',{staticClass:"w-100 h-100 d-flex align-items-center justify-content-center"},[(_vm.text)?_c('span',{key:"showText"},[_vm._v(_vm._s(_vm.text.toString()))]):(_vm.icon)?_c('b-icon',{key:"showIcon",staticClass:"text-white",attrs:{"icon":_vm.icon}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }